import { Dispatch, SetStateAction, createContext } from "react";

interface PreorderContext {
    currentQuantities?: number[][];
    currentTotalQuantity?: number;
    setCurrentQuantities?: Dispatch<SetStateAction<number[][]>>;
    selectedArticleHasMandatoryMenu: boolean;
    setSelectedArticleHasMandatoryMenu: Dispatch<SetStateAction<boolean>>;
    setGroupNames?: Dispatch<SetStateAction<string[]>>;
    nextInvalidGroup?: { name: string; index: number } | null;

    groupValidityMap?: Record<string | number, boolean>;
    isPreorderValid?: boolean;
    updateGroupValidity?: (groupId: string | number, isValid: boolean) => void;

    activeTabIndex?: number;
    setActiveTabIndex?: (index: number) => void;
}

export const PreorderContext = createContext<PreorderContext | undefined>(undefined);
